import { env } from "@repo/lib";

export const generateOnlinePaymentLink = (guid: string): string => {
  return `${env.VITE_EXPENSUM_URL}/checkout/${guid}`;
};
